import { environment } from '../environments/environment';

export class AppSettings {
  public static API_URI = environment.backend;
  public static API_URI_V2 = environment.backend_v2;
  public static API_ASSETS = environment.assets;
  public static API_EVENTS_ASSETS = environment.events_img;
  public static FAIL_LOGIN_URI = environment.uri_redirect_fail_login;
}
